export default "skymp5-front/22b76d454ef830957b945fc9e2e519f2.png";